/*eslint-disable no-script-url*/
/*global gtag*/
import React, { Component } from 'react';
import * as Common from '../components/Common';
import { Actions } from '../components/Actions';

import EmailTypePop from '../components/EmailTypePop';
import ServiceTypePop from '../components/ServiceTypePop';
import InquiryTypePop from '../components/InquiryTypePop';
import BranchSearchPop from '../components/BranchSearchPop';

class Voc extends Component {
  constructor(props) {
    super(props);

    this.state = {
      memberName: '',
      tel: '',
      email1: '',
      email2: '',
      email: '',
      emailType: '',
      serviceType: '토즈 스터디센터',
      inquiryType: '',
      branchName: '',
      branch_id: '',
      title: '',
      contents: '',
      isPrivacy: false,
      isOpenServiceTypePop: false,
      isOpenInquiryTypePop: false,
      isOpenEmailTypePop: false,
      isOpenBranchSearchPop: false
    }
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    if(params && params.membership_id) {
      this._getMembership(params.membership_id);
    }
  }

  _getMembership(membership_id) {
    Common.callApi('/membership/' + membership_id, 'get')
    .then(result => {
      if(result.resultCode.toLowerCase() === 'success') {
        if(result.resultData.memberName) {
          let _memberName = result.resultData.memberName;
          this._inputMemberName.value = _memberName;
          this.setState({ memberName: _memberName });
        }
        if(result.resultData.memberPhone) {
          let _tel = result.resultData.memberPhone.replaceAll('-', '');
          this._inputTel.value = _tel;
          this.setState({ tel: _tel });
        }
        if(result.resultData.email) {
          let _email = result.resultData.email;
          let _email1 = _email.split('@')[0];
          let _email2 = _email.split('@')[1];
          this._inputEmail1.value = _email1;
          this._inputEmail2.value = _email2;
          this.setState({
            email: _email,
            email1: _email1,
            email2: _email2,
          });
        }
      }
    });
  }

  _doOpenPop = (e) => {
    var type = e.target.dataset.type;

    if(type === 'inquiryType') {
      this.setState({ isOpenInquiryTypePop: true });
    } else if(type === 'emailType') {
      this.setState({ isOpenEmailTypePop: true });
    } else if(type === 'branchName') {
      this.setState({ isOpenBranchSearchPop: true });
    }

    Common.disableScroll();
  }

  _doClosePop = (e) => {
    var type = e.target.dataset.type;

    if(type === 'inquiryType') {
      this.setState({ 
        isOpenInquiryTypePop: false,
        inquiryType: e.target.dataset.inquirytype
      });
    } else if(type === 'emailType') {
      var emailType = e.target.dataset.emailtype;
      this.setState({ 
        isOpenEmailTypePop: false,
        emailType: emailType,
        email2: emailType
      });
    } else if(type === 'branchName') {
      var branch_id = e.target.dataset.branch_id;
      var branchName = e.target.dataset.branchname;
      this.setState({
        isOpenBranchSearchPop: false,
        branch_id: branch_id,
        branchName: branchName
      });
    }

    Common.enableScroll();
  }

  _checkValidation = () => {
    var msg = "";
    var isValidation = true;

    if(!this.state.memberName) {
      msg = "이름을 입력해주세요.";
    } else if(!this.state.tel) {
      msg = "휴대번호를 입력해주세요.";
    } else if(!Common.isPhoneNumberValidation(this.state.tel)) {
      msg = "휴대번호 형식에 맞지 않습니다.";
    } else if(!this.state.email1 || !this.state.email2) {
      msg = "이메일을 입력해주세요.";
    } else if(!Common.isEmailValidation(this.state.email1 + "@" + this.state.email2)) {
      msg = "이메일 형식에 맞지 않습니다.";
    } else if(!this.state.inquiryType) {
      msg = "문의유형을 선택해주세요.";
    } else if(!this.state.title) {
      msg = "제목을 입력해주세요.";
    } else if(!this.state.contents) {
      msg = "내용을 입력해주세요.";
    } else if(!this.state.isPrivacy) {
      msg = "개인정보 수집 및 이용에 동의해주세요.";
    }

    if(msg) {
      isValidation = false;
      Actions.alertOpen({msg: msg}, [{type: 'ok', label: '확인'}]);
    }
    return isValidation;
  }

  _doInquiry = () => {
    if(!this._checkValidation()) return false;

    var _params = {};
    _params.memberName = this.state.memberName
    _params.tel = Common.parsePhoneNumber(this.state.tel);
    _params.email = this.state.email1 + "@" + this.state.email2;
    _params.serviceType = this.state.serviceType;
    _params.inquiryType = this.state.inquiryType;
    _params.branch_id = this.state.branch_id;
    _params.title = this.state.title;
    _params.contents = this.state.contents;
    _params.isPrivacy = this.state.isPrivacy;
    _params.platform = "MOBILE";

    Common.callApi('/hp/voc/inquiry', 'post', _params)
    .then(result => {
      if(result.resultCode.toLowerCase() === 'success') {
        gtag('event', '문의완료', {'event_category': '고객의소리', 'event_label': '문의완료'});
        Actions.alertOpen({msg: '문의글 등록이 완료되었습니다.<br/>확인 후 빠른 시일 내에 답변 드리겠습니다.'}, [{type: 'ok', label: '확인', callback: Actions.doMovePage, param: '/introduce04'}]);
      }
    });
  }

  _doCancelConfirm() {
    Actions.alertOpen({msg: '입력하신 내용이 모두 사라집니다.<br/>그래도 취소할까요?'}, [{type: 'cancel', label: '취소'}, {type: 'ok', label: '확인', callback: this._doCancel}]);
  }

  _doCancel() {
    Actions.doMovePage('/voc');
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap" className="div-cont" >
              <div id="contents">
                <div className="app-header">
                  <p className="app-logo" onClick={() => {window.location.href = '/'}}><span className="blind">TOZ StudyCenter</span></p>
                  <a href="/introduce04" className="app-close"><span className="blind">닫기</span></a>
                </div>

                <div className="app-cont">
                  <div className="app-title02">
                    <p className="btxt">
                      <strong>고객의 소리</strong>
                    </p>
                    <p className="stxt">
                      요금 및 지점 이용과 관련한 문의는 해당 지점으로 유선 문의하시는 것이 빠르고 정확합니다.<br/>
                      문의하신 내용의 답변은 입력하신 이메일로 발송 드리오니 정확하게 입력 부탁드립니다.<br/>
                      <strong> 평일 10:00 ~ 18:00에 문의주신 글은 당일 확인 및 답변이 가능합니다. </strong>다만 문의내용에 따라 답변이 늦어질 수 있습니다.
                    </p>
                    <br/>
                    <p className="stxt"><span className="mgt">* 모든 입력사항은 필수입니다.</span></p>
                  </div>

                  <div className="app-info">
                    <ul className="list">
                      <li>
                        <p className="btxt">이름</p>
                        <input type="text" ref={ref => this._inputMemberName = ref} onKeyUp={e => this.setState({ memberName: e.target.value })} />
                      </li>
                      <li>
                        <p className="btxt">휴대번호</p>
                        <input type="tel" ref={ref => this._inputTel = ref} onKeyUp={e => this.setState({ tel: e.target.value })} />
                      </li>
                      <li>
                        <p className="btxt">이메일</p>
                        <input type="text" className="email1" ref={ref => this._inputEmail1 = ref} onKeyUp={e => this.setState({ email1: e.target.value })} />@
                        {this.state.emailType === '' ? <input type="text" className="email2" ref={ref => this._inputEmail2 = ref} onKeyUp={e => this.setState({ email2: e.target.value })} /> : ''}
                        <p className={this.state.emailType === '' ? "pop-sel layer-pop-open" : "pop-sel layer-pop-open email"} data-type="emailType" onClick={this._doOpenPop}>{this.state.emailType === '' ? '직접입력' : this.state.emailType}</p>
                      </li>
                      <li>
                        <p className="btxt">문의유형</p>
                        <p className="pop-sel layer-pop-open" data-type="inquiryType" onClick={this._doOpenPop}>{!this.state.inquiryType ? '문의유형 선택' : this.state.inquiryType}</p>
                      </li>
                      <li>
                        <p className="btxt">문의지점</p>
                        <p className="pop-sel layer-pop-open" data-type="branchName" onClick={this._doOpenPop}>{!this.state.branchName ? '문의지점 선택' : this.state.branchName}</p>
                      </li>
                      <li>
                        <p className="btxt">제목</p>
                        <input type="text" ref={ref => this._inputTitle = ref} onKeyUp={e => this.setState({ title: e.target.value })} />
                      </li>
                      <li>
                        <p className="btxt">내용</p>
                        <textarea ref={ref => this._inputContents = ref} onKeyUp={e => this.setState({ contents: e.target.value })} />
                      </li>
                    </ul>
                  </div>

                  <div className="close-center policy">
                    <p className="title">[필수] 개인정보 수집 및 이용안내</p>
                    <ul className="list">
                      <li>
                        <p className="btxt full">
                        ㈜티스터디컴퍼니는 아래의 목적으로 개인정보를 수집 및 이용하며, 회원의 개인정보를 안전하게 취급하는데 최선을 다합니다.<br/>
                        수집목적: 문의내용 확인 및 답변에 대한 의사소통 경로 확보<br/>
                        수집항목: 이름, 연락처, 메일주소<br/>
                        보유기간: 이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용 목적이 달성되면 지체 없이 파기하며 보유 기간은 최대 3년을 넘기지 않는 것을 원칙으로 합니다.<br/>
                        </p> 
                      </li>
                    </ul>
                  </div>
                  <ul className="agree-checks">
                    <li>
                      <p className="checks fr">
                        <input id="ex_cb1" type="checkbox" ref={ref => this._privacy = ref} onChange={e => this.setState({ isPrivacy: !this.state.isPrivacy })} />
                        <label htmlFor="ex_cb1">개인정보 수집 및 이용에 동의합니다.</label> 
                      </p>
                    </li>
                  </ul>

                  <div className="appinfo-fbtn inline">
                    <a href={null} className="b-btn white half fl" onClick={this._doCancelConfirm}>취소</a>
                    <a href={null} className="b-btn half fr" onClick={this._doInquiry}>문의</a>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>

        {!this.state.isOpenEmailTypePop ? '' : <EmailTypePop emailType={this.state.emailType} onClick={this._doClosePop} />}
        {!this.state.isOpenInquiryTypePop ? '' : <InquiryTypePop inquiryType={this.state.inquiryType} onClick={this._doClosePop} />}
        {!this.state.isOpenBranchSearchPop ? '' : <BranchSearchPop onClick={this._doClosePop} />}
      </div>
    )
  }
}

export default Voc;